import { useMemo } from "react"
import { usePopup } from "../popup";
import { Text } from "../../text/text";

import styles from "./confirmPopup.module.css";
import { Button } from "../../button/button";

export const useConfirmPopup = (title, subtitle, onApprove = () => {}, onCancel = () => {}) => {
    const [Popup, open, close] = usePopup();

    const popupObject = useMemo(() => {
        return (
            <Popup>
                <div className={styles.confirm_header}>
                    <Text as="div" variant="title" className={styles.popup_title} align="center">
                        {title}
                    </Text>
                    <Text as="div" variant="body" className={styles.confirm_subtitle} align="center">
                        {subtitle}
                    </Text>
                </div>

                <div className={styles.confirm_buttons}>
                    <Button text="Отменить" type="hint" onClick={() => {
                        onCancel();
                        close();
                    }} />
                    <Button text="Подтвердить" type="destructive" onClick={() => {
                        onApprove();
                        close();
                    }} />
                </div>
            </Popup>
        );
    }, [title, subtitle, onCancel, onApprove, close]);

    return [
        popupObject,
        open,
        close,
    ]
}